import React, { useMemo, useCallback } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import DocketItemStyles from '../DocketItem.styles';
import { RUSH_TAG } from '../../../common/constants';

export interface Props {
  tags?: string[];
  rushedAt?: number;
  docketCount?: string;
  onDocketCountClick?: (orderId: string) => void;
  orderId?: string;
  isSelected?: boolean;
}

const DocketTitleBar: React.FC<Props> = ({
  tags = [],
  rushedAt,
  docketCount,
  onDocketCountClick,
  orderId,
  isSelected = false,
}) => {
  const styles = DocketItemStyles({ isSelected });

  const displayTags = useMemo(
    () => [...(rushedAt ? [RUSH_TAG] : []), ...tags],
    [rushedAt, tags],
  );

  const handleDocketCountPress = useCallback(
    () => onDocketCountClick && orderId && onDocketCountClick(orderId),
    [onDocketCountClick, orderId],
  );

  if (!tags.length && !rushedAt && !docketCount) return null;

  return (
    <View testID="docket-title-bar" style={styles.tagsContainer}>
      <View style={styles.tagsRow}>
        {displayTags.map(tag => {
          const isRush = tag === RUSH_TAG;
          return (
            <View
              key={tag}
              style={[styles.tagBadge, isRush && styles.rushTagBadge]}
            >
              <Text style={[styles.tagLabel, isRush && styles.rushTagLabel]}>
                {tag}
              </Text>
            </View>
          );
        })}
      </View>
      {docketCount && (
        <TouchableOpacity
          style={[
            styles.docketCountBadge,
            isSelected && styles.docketCountBadgeSelected,
          ]}
          onPress={handleDocketCountPress}
        >
          <Text style={styles.docketCountLabel}>{docketCount}</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default React.memo(DocketTitleBar);
